<template>
  <div class="body evel-II">
    <el-card>
    <header class="header f-b-c">
      <h1 class="h1">{{ paperName }}</h1>
      <div class="f-c-c header-r">
        <!-- <img src="../../assets/images/clock.png" alt />
        <p>{{examTimeStr}}</p>-->
        <span
          style="color:white; padding-right:20px;font-size: 20px;"
          v-if="actualExamTime"
          >考试所用时长:{{ actualExamTime }}</span
        >
        <el-button
          v-show="$route.query.examDetailListId"
          type="success"
          @click="lookFalse"
          >{{ errorType ? "查看全部" : "查看错题集" }}
        </el-button>
        <el-button v-show="$route.query.name" type="success" @click="exportFile"
          >导出</el-button
        >
        <el-button  @click="$router.go(-1)">返回</el-button>
      </div>
    </header>
    <main class="main">
      <!-- <p class="result-p">总成绩：0.0分，正确率：0.00%，已通过考试</p> -->
      <div v-for="(item, index) in singleChoiceList" :key="index" class="mb20">
        <h2 class="test-title">
          {{ item.questionTitle }}（共{{ item.questionNumber }}题，总共{{
            item.questionFractionTotal
          }}分）
        </h2>
        <div
          v-for="(item2, index2) in item.trainingQuestionsLibrary"
          :key="index2"
        >
          <div
            class="p20"
            v-if="errorType == false || item2.questionFraction == 0"
          >
            <h3 class="item-title">
              <span class="xuhao">{{ item2.index }}.</span
              ><span v-html="item2.questionStemContent"></span>
            </h3>
            <p
              class="answer"
              v-for="(option, index3) in item2.trainingQuestionsAnswerDataVos"
              :key="index3"
            >
              <span class="xuhao2"
                >{{
                  index3 == 0
                    ? "A"
                    : index3 == 1
                    ? "B"
                    : index3 == 2
                    ? "C"
                    : index3 == 3
                    ? "D"
                    : index3 == 4
                    ? "E"
                    : index3 == 5
                    ? "F"
                    : index3 == 6
                    ? "E"
                    : "G"
                }}.
              </span>
              <span class="answer" v-html="option.quetionAnswer"></span>
            </p>

            <div v-if="$route.query.examDetailListId">
              <p style="color:black;" class="answer">
                考生得分:{{ item2.questionFraction }}
              </p>
              <p style="color:black;" class="answer">
                考生答案:
                <span
                  v-for="(option,
                  index3) in item2.trainingQuestionsAnswerDataVos"
                  :key="index3"
                >
                  <span v-if="option.checkStatus == 0">{{
                    index3 == 0
                      ? "A"
                      : index3 == 1
                      ? "B"
                      : index3 == 2
                      ? "C"
                      : index3 == 3
                      ? "D"
                      : index3 == 4
                      ? "E"
                      : index3 == 5
                      ? "F"
                      : index3 == 6
                      ? "E"
                      : "G"
                  }}</span>
                </span>
                <span v-if="item2.questionFraction > 0" class="true">✔</span>
                <span v-else class="false">×</span>
              </p>
              <p style="color:black;" class="answer">
                标准答案:
                <span
                  v-for="(option,
                  index3) in item2.trainingQuestionsAnswerDataVos"
                  :key="index3"
                >
                  <span v-if="option.trueStatus == 0">{{
                    index3 == 0
                      ? "A"
                      : index3 == 1
                      ? "B"
                      : index3 == 2
                      ? "C"
                      : index3 == 3
                      ? "D"
                      : index3 == 4
                      ? "E"
                      : index3 == 5
                      ? "F"
                      : index3 == 6
                      ? "E"
                      : "G"
                  }}</span>
                </span>
              </p>
              <p style="color:black;" class="answer">
                试题分析:
                <span v-html="item2.questionAnalysis"></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  </el-card>
  </div>
</template>

<script>
import exam from "@/api/new/exam.js";
import util from "@/common/util";
export default {
  data() {
    return {
      radio: "",
      checkbox: [],
      paperName: "",
      examSecond: 600, //考试时长，秒
      examTimeStr: "00分00秒", //考试时长，字符串
      tiemr: null,
      singleChoiceList: [],
      errorType: false,
      actualExamTime: ""
    };
  },
  mounted() {
    this.getPaperDetail();
  },
  methods: {
    lookFalse() {
      this.errorType = !this.errorType;
      this.getPaperDetail();
    },
    exportFile() {
      exam
        .trainingDetailExportPaper({
          examDetailId: this.$route.query.examDetailListId
        })
        .then(res => {
          let name = this.$route.query.name || "";
          util.downloadBlobFile(res, `${name}${this.paperName}详情.docx`);
        });
    },
    getPaperDetail() {
      if (this.$route.query.examDetailListId) {
        exam
          .getPaperNewDetail({
            paperId: this.$route.query.id,
            errorType: this.errorType,
            examDetailListId: this.$route.query.examDetailListId
              ? this.$route.query.examDetailListId
              : undefined
          })
          .then(res => {
            if (!res.data.questionsPaperName) {
              this.$message.error("当前考试内容为空");
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000);
              return;
            }
            this.paperName = res.data.questionsPaperName;
            this.actualExamTime = res.data.actualExamTime;
            this.singleChoiceList =
              res.data.trainingPaperSetups.trainingPaperSetupDataVos;
          });
      } else {
        exam
          .getPaperDetail({
            paperId: this.$route.query.id,
            errorType: false,
            examDetailListId: this.$route.query.examDetailListId
              ? this.$route.query.examDetailListId
              : undefined
          })
          .then(res => {
            if (!res.data.questionsPaperName) {
              this.$message.error("当前考试内容为空");
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000);
              return;
            }
            this.paperName = res.data.questionsPaperName;
            this.singleChoiceList =
              res.data.trainingPaperSetups.trainingPaperSetupDataVos;
          });
      }
    }
  }
};
</script>

<style scoped>
.answer > p:first-child {
  display: inline-block;
}
.exam {
  overflow: auto;
  height: 100vh;
}
.exam .el-card__body {
  padding: 0 !important;
}
.header {
  background: #5D8C82;
  border-radius: 6px 6px 0px 0px;
  height: 65px;
  padding-right: 15px;
}
.h1 {
  padding-left: 20px;
  color: white;
}
.header-r > img {
  height: 60px;
}
.header-r > p {
  font-size: 22px;
  color: white;
  margin-right: 50px;
}
.main {
  width: 50vw;
  padding: 50px;
  margin-top: 100px;
}
.test-title {
  background: #dedede;
  font-size: 20px;
  font-weight: 600;
  line-height: 50px;
  padding-left: 15px;
  border-radius: 5px;
}
.item-title {
  line-height: 40px;
  position: relative;
}
.row {
  padding: 12px 0;
}
.result-p {
  font-size: 18px;
  margin-bottom: 8px;
}
.answer {
  line-height: 35px;
  padding-left: 10px;
  position: relative;
}
.true {
  color: green;
  font-size: 20px;
  font-weight: 600;
}
.false {
  color: red;
  font-size: 20px;
  font-weight: 600;
}
.xuhao {
  position: absolute;
  left: -25px;
  top: 0;
  white-space: nowrap;
}
.xuhao2 {
  position: absolute;
  left: 0px;
  top: 0;
  white-space: nowrap;
}
</style>
<style>
.exam img {
  max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/student/lookExam.vue